import React, { Component } from 'react';
import { Grid, Dropdown, Form, Button, Icon, Segment, Header } from 'semantic-ui-react';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { reportType } from '../../utils/defaults';
import { getPaymentReport } from '../../utils/rest';
import MessageBox from '../../ui/MessageBox';
import * as SimpleReactValidator from 'simple-react-validator';
import Loading from '../Loading';
class PaymentReport extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            searchIndex: {
                from: "",
                to: "",
                cltClientIds: [],
                type: ""
            },
            errorMessage: [],
            open: false
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "reports_payment.md");
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    componentDidUpdate(prevProps) {
        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.setState({
                searchIndex: {
                    from: "",
                    to: "",
                    cltClientIds: [],
                    type: ""
                },
                errorMessage: [],
                open: false
            });
        }
    }

    handleChange = (e, data) => {
        this.setState({
            searchIndex: {
                ...this.state.searchIndex,
                [data.name]: data.value
            }
        });
    }

    close = () => {
        this.setState({
            open: false
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loading: true
            }, () => {
                getPaymentReport(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                    if (response !== null) {
                        let disposition = response.request.getResponseHeader('Content-Disposition');
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            let matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                let filename = matches[1].replace(/['"]/g, '');
                                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                                    // IE workaround for "HTML7007: One or more blob URLs were 
                                    // revoked by closing the blob for which they were created. 
                                    // These URLs will no longer resolve as the data backing 
                                    // the URL has been freed."
                                    window.navigator.msSaveBlob(new Blob([response.data]), filename);
                                } else {
                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.setAttribute('download', filename);
                                    document.body.appendChild(link);
                                    link.click();
                                }
                            }
                        }
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    });
                })
            });
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                open: true
            });
            this.forceUpdate();
        }

    }

    render() {
        return (
            <div>
                {this.state.loading ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Reports" child={[{ name: "Payment", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment inverted className="grey">
                                    <Header as="h4">Payment Report</Header>
                                </Segment>
                                <Segment>
                                    <Form className="small">
                                        <Form.Group>
                                            <Form.Field width={4} className="required">
                                                <label>Select Client ID(s):</label>
                                                <Dropdown placeholder='Select Client ID(s)' className="fluid" multiple search selection options={this.props.items.clients.map((client) => { client.disabled = !client.allowedtoviewreport; return client; })} value={this.state.searchIndex.cltClientIds} name="cltClientIds" onChange={this.handleChange}></Dropdown>
                                                {this.validator.message('Client ID', this.state.searchIndex.cltClientIds, 'required')}
                                            </Form.Field>
                                            <Form.Field width={4} className="required">
                                                <label>Start Date:</label>
                                                <Form.Input placeholder='mm/dd/yyyy' type="date" value={this.state.searchIndex.from} name="from" onChange={this.handleChange} />
                                                {this.validator.message('Start Date', this.state.searchIndex.from, 'required')}
                                            </Form.Field>
                                            <Form.Field width={4} className="required">
                                                <label>End Date:</label>
                                                <Form.Input placeholder='mm/dd/yyyy' type="date" value={this.state.searchIndex.to} name="to" onChange={this.handleChange} />
                                                {this.validator.message('End Date', this.state.searchIndex.to, 'required')}
                                            </Form.Field>
                                            <Form.Field width={4} />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Field width={10} className="required">
                                                <label>Choose a Report Type:</label>
                                                <Dropdown placeholder='Select' className="fluid" search selection options={reportType} value={this.state.searchIndex.type} name="type" onChange={this.handleChange}></Dropdown>
                                                {this.validator.message('Choose a Report Type', this.state.searchIndex.type, 'required')}
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Button labelPosition='left' labeled className='icon button small floated push-down' onClick={this.handleSubmit} >
                                                    <Icon name="external alternate" />Export Table Data
                                        </Button>
                                            </Form.Field>
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={11} open={this.state.open} close={this.close} required={this.state.errorMessage} />
            </div>
        );
    }
}
export default PaymentReport;


// WEBPACK FOOTER //
// ./src/app/ui/reports/PaymentReport.js